// @ts-nocheck
import { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import dayjs from 'dayjs'
import RiskAssessmentItem from '../../screens/Residents/screens/ResidentRiskAssessmentsScreens/components/RiskAssessmentItem'
import { colors } from '@lmc/common/constants'
import { getNominative } from '../../common/utils'
import { showToast } from '../../common/utils'
import CarePlanAction from './CarePlanAction'
import ConfirmationDialog from '../../LEGACY/ConfirmationDialog'
import { FormCard, Button, Add } from '@lmc/ui-kit'
import { Carer } from '@lmc/ts-common'
import { Heading, Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

type Props = {
  carers: Carer[]
  fields?: any
  riskAssessments?: any
  router?: any
  setFormField?: any
  onOpenModal?: any
  showToast?: any
}

export class RiskAssessmentsSection extends Component<Props, any> {
  state = {
    removeDialogOpen: false,
    assessmentToRemove: null,
  }

  openRemoveDialog = (id) => {
    this.setState({
      removeDialogOpen: true,
      assessmentToRemove: id,
    })
  }

  closeRemoveDialog = () => {
    this.setState({ removeDialogOpen: false })
  }

  handleRemoveRiskAssessment = () => {
    const { fields, setFormField } = this.props
    const currentAssessments = _.clone(fields.riskAssessments)
    setFormField({
      key: 'riskAssessments',
      value: _.pull(currentAssessments, this.state.assessmentToRemove),
    })
    showToast({ type: 'info', title: 'Removed a Risk Assessment' })
    this.setState({
      removeDialogOpen: false,
    })
  }

  handleRiskAssessmentView = (id) => {
    const resident = this.props.router.params.id
    window.open(`/residents/${resident}/risk-assessments/${id}`, '_blank')
  }

  handleOpenModal = (row) => {
    window.scrollTo(0, 0)
    this.props.onOpenModal(row)
  }

  handleRemove = (id) => {
    this.setState({
      removeDialogOpen: true,
      assessmentToRemove: id,
    })
  }

  getRiskAssessments = () => {
    const { carers, riskAssessments, fields } = this.props

    return _(fields.riskAssessments)
      .map((id) => _.find(riskAssessments, { id }))
      .compact()
      .map((row) => ({
        ...row,
        createdBy: _.find(carers, { id: row.createdBy }),
      }))
      .sortBy('form.name')
      .value()
  }

  getActions = (riskAssessments) => {
    if (
      !riskAssessments ||
      _.every(
        riskAssessments,
        (assessment) => !assessment.formData || !assessment.formData.actions
      )
    ) {
      return null
    }
    return riskAssessments.map((row) => {
      if (!row.formData || !row.formData.actions) return null
      return (
        <CarePlanAction
          key={row.id}
          title={row.form.name}
          text={row.formData.actions}
        />
      )
    })
  }

  shouldShowUpdateAlert = (row) => {
    const { fields } = this.props
    if (!fields) return false

    const { editedOn, reviewedAssessments } = fields
    return (
      editedOn &&
      dayjs(editedOn).isBefore(row.createdOn) &&
      (!reviewedAssessments || !reviewedAssessments.includes(row.id))
    )
  }

  renderRisks = () => {
    const { readOnly, carePlanNominative } = this.props
    const riskAssessments = this.getRiskAssessments()
    const hasRiskAssessments = riskAssessments && riskAssessments.length

    return (
      <div style={styles.sectionContainer}>
        <FormCard
          title="Risks"
          rightChildren={
            !readOnly && (
              <Button
                type="button"
                variant="text"
                icon={<Add />}
                onClick={() => this.handleOpenModal()}
              >
                Add Risk Assessments
              </Button>
            )
          }
        >
          {hasRiskAssessments ? (
            <div style={styles.riskAssessmentsContainer}>
              {riskAssessments.map((row) => {
                const hasActions =
                  !!row?.form?.hasActions && !!row?.formData?.actions

                return (
                  <>
                    <RiskAssessmentItem
                      readOnly={readOnly}
                      carer={row.createdBy}
                      key={row.id}
                      riskAssessment={row}
                      onDelete={!readOnly && this.handleRemove}
                      onEdit={!readOnly && this.handleOpenModal}
                      onView={this.handleRiskAssessmentView}
                      showUpdateAlert={this.shouldShowUpdateAlert(row)}
                      carePlanNominative={carePlanNominative || undefined}
                    />
                    {hasActions && (
                      <WrapperActions>
                        <StyledHeading level={3}>
                          Actions for {row?.form?.name}
                        </StyledHeading>
                        <StyledText>{row?.formData?.actions}</StyledText>
                      </WrapperActions>
                    )}
                  </>
                )
              })}
            </div>
          ) : null}
        </FormCard>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.renderRisks()}
        <ConfirmationDialog
          confirmationLabel="OK"
          confirmationType="warning"
          isOpen={this.state.removeDialogOpen}
          onCancel={this.closeRemoveDialog}
          onConfirmation={this.handleRemoveRiskAssessment}
        >
          {getRemoveConfirmMessage(this.props.carePlanNominative)}
        </ConfirmationDialog>
      </div>
    )
  }
}

const getRemoveConfirmMessage = (carePlanNominative) =>
  `Are you sure you want to remove this risk assessment from this ${getNominative(
    carePlanNominative,
    'Care Plan'
  )}?`

const styles = {
  riskAssessmentsContainer: {
    paddingTop: 5,
    whiteSpace: 'pre-wrap',
  },
  actionsNote: {
    color: colors.darkgrey,
    display: 'block',
    fontSize: 12,
    marginTop: 12,
  },
  actionsContainer: {
    marginTop: 15,
    padding: '15px 25px 18px',
    whiteSpace: 'pre-wrap',
  },
  sectionContainer: {
    paddingTop: 30,
  },

  infoBoxContainer: {
    marginTop: 15,
  },
}

const WrapperActions = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  margin-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  padding: 24px;
  background-color: ${(props) => props.theme.color.neutral.color10};
  border-radius: 15px;
`

const StyledHeading = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color4};
  border-bottom: 1px solid;
  border-color: ${(props) => props.theme.color.neutral.color8};
  margin-bottom: 10px;
  padding-bottom: 10px;
`

const StyledText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color3};
`

const mapStateToProps = (state) => ({
  carePlanNominative: state.global.home.preferredCarePlansNominative,
})

export default connect(mapStateToProps, null)(RiskAssessmentsSection)
